import { FC } from 'react';
import { Control, Controller, UseFormReturn } from 'react-hook-form';
import { Form } from 'antd';

import { BrokerContactForm } from '@/shared/lib/forms/contacts/broker';
import { useFormRenderV2 } from '@/shared/lib/hooks/useFormRenderV2';
import { getRequiredRule } from '@/shared/lib/hooks/useFormRenderV2/helpers';
import { ContactDto } from '@/shared/lib/sj-orm';
import { QuestionType } from '@/shared/lib/sj-orm/models/form/question.dto';
import { Icon } from '@/shared/uikit/Icon';
import { Input } from '@/shared/uikitV2/Input';
import { useTranslation } from '@/shared/utils/i18n/useTranslation';

import { ContactTypeI18n } from '../../ContactTypeI18n';
import { InputWrap, ValueView } from '../styled';

type BrokerFastFormData = Pick<ContactDto, 'nickname' | 'selectedCountry' | 'brokerAddress'> &
  Partial<Pick<ContactDto, 'createdAt' | 'updatedAt'>>;
type BrokerFastHelpType = {
  nickname: QuestionType.TEXT;
  selectedCountry: QuestionType.SELECT_FROM_LIST;
  brokerAddress: QuestionType.TEXT;
};

const brokerFastSectionItems = {
  nickname: BrokerContactForm.nickname,
  selectedCountry: BrokerContactForm.selectedCountry,
  brokerAddress: BrokerContactForm.brokerAddress,
};

type BrokerFormProps = {
  onSubmit: (e?: React.BaseSyntheticEvent) => Promise<void>;
  formId: string;
  control: Control<ContactDto, unknown>;
  form: UseFormReturn<ContactDto, unknown, undefined>;
};

export const BrokerForm: FC<BrokerFormProps> = ({ onSubmit, formId, control, form }) => {
  const { t } = useTranslation('widgets/modals', { keyPrefix: 'fastCreateContact' });
  const { Component } = useFormRenderV2<BrokerFastFormData, BrokerFastHelpType>({
    form: form as unknown as UseFormReturn<BrokerFastFormData, unknown, undefined>,
    sectionItems: brokerFastSectionItems,
  });

  return (
    <Form onFinish={onSubmit} id={formId} style={{ display: 'contents' }}>
      <Controller
        control={control}
        name="type"
        rules={{ required: getRequiredRule({ required: true }) }}
        render={({ field, fieldState }) => (
          <InputWrap>
            <Input
              {...field}
              errorText={fieldState.error?.message}
              status={fieldState.error ? 'error' : 'default'}
              label={t('fields.type')}
              iconAfter={field.value ? <Icon name="lock" size="s16" /> : null}
              readOnly
              required
            />
            <ValueView>
              <ContactTypeI18n type={field.value} />
            </ValueView>
          </InputWrap>
        )}
      />
      {Component}
    </Form>
  );
};
